/**
 * @generated SignedSource<<49bf4c7442ef3e0b533fb7ee73936383>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksArticlePageArticleSpeechConfigArticle$data = {
  readonly articleSpeechConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "hooksArticlePageArticleSpeechConfigArticle";
};
export type hooksArticlePageArticleSpeechConfigArticle$key = {
  readonly " $data"?: hooksArticlePageArticleSpeechConfigArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksArticlePageArticleSpeechConfigArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "hooksArticlePageArticleSpeechConfigArticle",
  "selections": [
    {
      "alias": "articleSpeechConfig",
      "args": [
        {
          "kind": "Literal",
          "name": "filter",
          "value": {
            "entityId": "scmp_pwa_article_speech"
          }
        }
      ],
      "concreteType": "AppConfigs",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "json",
          "storageKey": null
        }
      ],
      "storageKey": "appConfig(filter:{\"entityId\":\"scmp_pwa_article_speech\"})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "2a9780a5370343356f38eddcf31ddf06";

export default node;
